/**
 * Every Petlings species, in the order the app's catalog lists them, with
 * its name and tier. The one list the site's pet pictures read from: the
 * art, the parades, the About page, the aliases.
 *
 * Source of truth: the iOS app's PetCatalog.swift, itself generated from the
 * backend's economy.py. The live catalog API still decides prices and
 * ownership; this is only what a species is called and how it is drawn.
 */
export const PETS = [
  { id: 'cat', name: 'Cat', tier: 'free' },
  { id: 'chicken', name: 'Chicken', tier: 'free' },
  { id: 'fox', name: 'Fox', tier: 'free' },
  { id: 'ocelot', name: 'Ocelot', tier: 'free' },
  { id: 'parrot', name: 'Parrot', tier: 'free' },
  { id: 'pig', name: 'Pig', tier: 'free' },
  { id: 'rabbit', name: 'Rabbit', tier: 'free' },
  { id: 'wolf', name: 'Wolf', tier: 'free' },
  { id: 'allay', name: 'Allay', tier: 'plus' },
  { id: 'armadillo', name: 'Armadillo', tier: 'plus' },
  { id: 'axolotl', name: 'Axolotl', tier: 'plus' },
  { id: 'bee', name: 'Bee', tier: 'plus' },
  { id: 'camel', name: 'Camel', tier: 'plus' },
  { id: 'cow', name: 'Cow', tier: 'plus' },
  { id: 'frog', name: 'Frog', tier: 'plus' },
  { id: 'goat', name: 'Goat', tier: 'plus' },
  { id: 'sheep', name: 'Sheep', tier: 'plus' },
  { id: 'sniffer', name: 'Sniffer', tier: 'plus' },
  { id: 'strider', name: 'Strider', tier: 'plus' },
  { id: 'turtle', name: 'Turtle', tier: 'plus' },
  { id: 'horse', name: 'Horse', tier: 'premium' },
  { id: 'iron_golem', name: 'Iron Golem', tier: 'premium' },
  { id: 'llama', name: 'Llama', tier: 'premium' },
  { id: 'polar_bear', name: 'Polar Bear', tier: 'premium' },
  { id: 'snow_golem', name: 'Snow Golem', tier: 'premium' },
  { id: 'baby_dragon', name: 'Baby Dragon', tier: 'individual' },
  { id: 'clockwork_sentinel', name: 'Clockwork Sentinel', tier: 'individual' },
  { id: 'dolphin', name: 'Dolphin', tier: 'individual' },
  { id: 'duck_parade', name: 'Duck Parade', tier: 'individual' },
  { id: 'hermit_crab', name: 'Hermit Crab', tier: 'individual' },
  { id: 'jellyfish_bloom', name: 'Jellyfish Bloom', tier: 'individual' },
  { id: 'lantern_imp', name: 'Lantern Imp', tier: 'individual' },
  { id: 'mini_gryphon', name: 'Mini Gryphon', tier: 'individual' },
  { id: 'mocchi_rabbit', name: 'Mocchi Rabbit', tier: 'individual' },
  { id: 'nimbus_pup', name: 'Nimbus Pup', tier: 'individual' },
  { id: 'panda', name: 'Panda', tier: 'individual' },
  { id: 'pigmy_kraken', name: 'Pigmy Kraken', tier: 'individual' },
  { id: 'pocket_phoenix', name: 'Pocket Phoenix', tier: 'individual' },
  { id: 'shadowling_wolf', name: 'Shadowling', tier: 'individual' },
  { id: 'slime', name: 'Elemental Slime', tier: 'individual' },
  { id: 'star_sprite', name: 'Star Sprite', tier: 'individual' },
  { id: 'wisp', name: 'Wisp', tier: 'individual' },
];

export const TIER_LABELS = { free: 'Free', plus: 'Plus', premium: 'Premium', individual: 'Individual' };

/** Ids some parts of the site and the backend use that differ from the art. */
const ALIASES = { shadowling: 'shadowling_wolf' };

const BY_ID = Object.fromEntries(PETS.map((p) => [p.id, p]));

/** The species id the art and models are filed under. */
export function resolvePetId(id) {
  const plain = String(id || '').replace(/^unlock_/, '');
  return ALIASES[plain] || plain;
}

export function petInfo(id) {
  return BY_ID[resolvePetId(id)] || null;
}

export function petName(id) {
  return petInfo(id)?.name || String(id || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
